import { normalizeLocalizedField } from './richText';

export const BLOG_LOCALES = ['es', 'en', 'pt'];
export const ARTICLE_STATUSES = ['draft', 'published', 'scheduled', 'archived'];
export const TRANSLATION_STATUSES = ['missing', 'draft', 'ready'];

export const createEmptyLocalizedField = () => ({ es: '', en: '', pt: '' });

export const createEmptyImageAsset = () => ({
  storagePath: '',
  url: '',
  width: 0,
  height: 0,
  mimeType: '',
  sizeBytes: 0,
  alt: createEmptyLocalizedField(),
});

export const normalizeLocalizedSlug = (value) => {
  const normalized = normalizeLocalizedField(value, createEmptyLocalizedField());

  return Object.fromEntries(
    Object.entries(normalized).map(([locale, slug]) => [locale, slugify(slug)])
  );
};

export const normalizeTranslationStatus = (value) => {
  const base = { es: 'missing', en: 'missing', pt: 'missing' };

  if (!value || typeof value !== 'object') {
    return base;
  }

  return Object.fromEntries(
    BLOG_LOCALES.map((locale) => {
      const status = value[locale];
      return [locale, TRANSLATION_STATUSES.includes(status) ? status : 'missing'];
    })
  );
};

export const slugify = (value = '') => (
  value
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-')
);

export const buildArticleSlugRegistryId = (locale, slug) => `${locale}__${slugify(slug)}`;

export const createEmptyArticle = (overrides = {}) => {
  const article = {
    id: '',
    status: 'draft',
    authorId: '',
    authorName: '',
    localePriority: 'en',
    title: createEmptyLocalizedField(),
    slug: createEmptyLocalizedField(),
    excerpt: createEmptyLocalizedField(),
    content: createEmptyLocalizedField(),
    seoTitle: createEmptyLocalizedField(),
    seoDescription: createEmptyLocalizedField(),
    coverImage: createEmptyImageAsset(),
    socialImage: createEmptyImageAsset(),
    categoryIds: [],
    tagIds: [],
    relatedArticleIds: [],
    readingTimeMinutes: 0,
    featured: false,
    // Archived only: the article its old links send people to ('' = gone, 410).
    redirectTo: '',
    // Photos waiting for Claude to place them (editor, "Ask Claude for changes").
    inboxImages: [],
    translationStatus: normalizeTranslationStatus(),
    publishedAt: null,
    scheduledFor: null,
    createdAt: null,
    updatedAt: null,
    createdBy: '',
    updatedBy: '',
    ...overrides,
  };

  article.slug = normalizeLocalizedSlug(article.slug || createEmptyLocalizedField());
  article.translationStatus = normalizeTranslationStatus(article.translationStatus);

  return article;
};

export const createEmptyCategory = (overrides = {}) => {
  const category = {
    id: '',
    name: createEmptyLocalizedField(),
    slug: createEmptyLocalizedField(),
    description: createEmptyLocalizedField(),
    seoTitle: createEmptyLocalizedField(),
    seoDescription: createEmptyLocalizedField(),
    sortOrder: 0,
    isActive: true,
    createdAt: null,
    updatedAt: null,
    ...overrides,
  };

  category.slug = normalizeLocalizedSlug(category.slug || createEmptyLocalizedField());

  return category;
};